import { Collapse } from '@mui/material';
import ImageLibraryImageGuidelines from './ImageLibraryImageGuidelines';
import ImageLibraryDesignGuidelines from './ImageLibraryDesignGuidelines';

export const GUIDELINES_CONTENT_ID = 'image-library-browser-guidelines';

export interface ImageLibraryGuidelinesContentProps {
	mobileGuidelines: boolean
	opened: boolean
}

export default function ImageLibraryGuidelinesContent(props: ImageLibraryGuidelinesContentProps) {
	return <Collapse in={!props.mobileGuidelines || props.opened} timeout="auto" unmountOnExit={props.mobileGuidelines}>
		<div id={GUIDELINES_CONTENT_ID}>
			<ImageLibraryImageGuidelines />
			<ImageLibraryDesignGuidelines />
		</div>
	</Collapse>
}
